import React from 'react';
import { VStack, HStack, useToast as useNativeToast } from 'native-base';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faCircleCheck, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';

export const useToast = () => {

    const toast = useNativeToast();

    const DURATION = 5000; // 5 seconds

    const {
        radius_md,
    } = useTheme();

    const successToast = (title: string, description?: string) => {

        const id = Math.random().toString(36).substring(7);

        toast.show({
            id,
            render: () => {

                return (
                    <VStack
                        space={2}
                        bg={'success'}
                        color={'white'}
                        rounded={radius_md}
                        px={6}
                        py={3}
                        w={'clamp(320px, 100vw, 480px)'}
                    >
                        <HStack space={2} alignItems={'center'}>
                            <SpIcon icon={faCircleCheck} />
                            <Caption bold={!!description}>
                                { title }
                            </Caption>
                        </HStack>
                        { description &&
                            <Caption>
                                { description }
                            </Caption>
                        }
                    </VStack>
                );
            },
            placement: 'bottom',
            duration: DURATION
        });
    };

    const errorToast = (title: string, description?: string) => {

        const id = Math.random().toString(36).substring(7);

        toast.show({
            id,
            render: () => {

                return (
                    <VStack
                        space={2}
                        bg={'danger'}
                        color={'white'}
                        rounded={radius_md}
                        px={6}
                        py={3}
                        w={'clamp(320px, 100vw, 480px)'}
                    >
                        <HStack space={2} alignItems={'center'}>
                            <SpIcon icon={faXmarkCircle} />
                            <Caption bold={!!description}>
                                { title }
                            </Caption>
                        </HStack>
                        { description &&
                            <Caption>
                                { description }
                            </Caption>
                        }
                    </VStack>
                );
            },
            placement: 'bottom',
            duration: DURATION
        });
    };

    return {
        successToast,
        errorToast
    };
};
